import Grid, { GridProps } from '@mui/material/Grid';

interface Props extends GridProps {}

export const CenterPositionedRow = (props: Props) => {
  return (
    <Grid
      {...props}
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ ...props.sx }}
    />
  );
};
